<template>
  <el-card v-loading="loading">
    <div slot="header">
      <el-form :model="searchData" size="mini" :inline="true">
        <template v-if="bulletinsType === 'transfer'">
          <el-form-item label="行业" prop="行业">
            <el-select v-model="searchData['行业']" filterable>
              <el-option v-for="(hangye, k) in transferHangyes" :key="k" :label="hangye" :value="hangye"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司" prop="公司">
            <el-autocomplete v-model="searchData['公司']" :fetch-suggestions="querySearch"></el-autocomplete>
          </el-form-item>
          <el-form-item label="模块" prop="模块">
            <el-select v-model="searchData['模块']" multiple filterable placeholder="选择">
              <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="变动因素" prop="变动因素">
            <el-select v-model="searchData['变动因素']" filterable placeholder="选择">
              <el-option v-for="t in transferFuncType" :key="t" :label="t" :value="t"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="变动影响程度" prop="变动影响程度">
            <el-select v-model="searchData['变动影响程度']" filterable placeholder="选择">
              <el-option v-for="level in transferFuncLevel" :key="level" :label="level" :value="level"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="变动简述"> <el-input v-model="searchData['变动描述']"></el-input> </el-form-item>
          <el-form-item label="详情" prop="详情"> <el-input v-model="searchData['详情']"></el-input> </el-form-item>
        </template>
        <template v-else-if="bulletinsType === 'bd'">
          <el-form-item label="公司" prop="公司">
            <el-autocomplete v-model="searchData['公司']" :fetch-suggestions="querySearch"></el-autocomplete>
          </el-form-item>
          <el-form-item label="模块" prop="模块">
            <el-select v-model="searchData['模块']" multiple filterable placeholder="选择">
              <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门" prop="部门"> <el-input v-model="searchData['部门']"></el-input> </el-form-item>
          <el-form-item label="岗位名称" prop="岗位名称">
            <el-input v-model="searchData['岗位名称']"></el-input>
          </el-form-item>
          <el-form-item label="岗位类型" prop="岗位类型">
            <el-select v-model="searchData['岗位类型']" filterable>
              <el-option v-for="(type, k) in bdType" :key="k" :label="type" :value="type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="汇报上级" prop="汇报上级">
            <el-input v-model="searchData['汇报上级']"></el-input>
          </el-form-item>
          <el-form-item label="岗位详情" prop="岗位详情">
            <el-input v-model="searchData['岗位详情']"></el-input>
          </el-form-item>
          <el-form-item label="揭榜人" prop="揭榜人">
            <el-select v-model="searchData['揭榜人']" filterable placeholder="请选择">
              <el-option v-for="item in accounts" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="BD进展" prop="BD进展">
            <el-input v-model="searchData['BD进展']"></el-input>
          </el-form-item>
        </template>
        <template v-else-if="bulletinsType === 'others'">
          <el-form-item label="标题" prop="标题"> <el-input v-model="searchData['标题']"></el-input> </el-form-item>
          <el-form-item label="内容" prop="内容"> <el-input v-model="searchData['内容']"></el-input> </el-form-item>
        </template>
        <el-form-item label="发布人" prop="发布人">
          <el-select v-model="searchData['发布人']" filterable placeholder="请选择">
            <el-option v-for="item in accounts" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item> <el-button type="primary" size="mini" @click="loadBulletins">搜索</el-button> </el-form-item>
        <el-form-item> <el-button size="mini" @click="clearSearch">清空</el-button> </el-form-item>
      </el-form>
      <div><el-button size="mini" @click="addBulletin">创建情报</el-button></div>
    </div>
    <el-tabs v-model="bulletinsType" @tab-click="clearSearch">
      <el-tab-pane label="变动信息" name="transfer">
        <el-table v-if="bulletinsType === 'transfer'" :data="bulletinData" size="mini" style="width: 100%">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="行业" label="行业" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="公司" label="公司" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="模块" label="模块" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="变动因素" label="变动因素" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column
            prop="变动影响程度"
            label="变动影响程度"
            width="150"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column prop="变动描述" label="变动描述" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="详情" label="详情" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="发布人" label="发布人" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="时间" label="时间" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editBulletin(scope.row)">详情</el-button>
              <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="招聘信息" name="bd">
        <el-table v-if="bulletinsType === 'bd'" :data="bulletinData" size="mini" style="width: 100%">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="公司" label="公司" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="岗位类型" label="岗位类型" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="模块" label="模块" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="部门" label="部门" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="岗位名称" label="岗位名称" width="150" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="汇报上级" label="汇报上级" width="150" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="发布人" label="发布人" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="时间" label="时间" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="揭榜人" label="揭榜人" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="BD进展" label="BD进展" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editBulletin(scope.row)">详情</el-button>
              <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="其他情报" name="others">
        <el-table v-if="bulletinsType === 'others'" :data="bulletinData" size="mini" style="width: 100%">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="标题" label="标题" width="150" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="内容" label="内容" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="发布人" label="发布人" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="时间" label="时间" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editBulletin(scope.row)">详情</el-button>
              <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="formData._id ? '编辑情报' : '创建情报'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-tabs v-model="bulletinsType">
        <el-tab-pane v-if="isTabShow('transfer')" label="变动信息" name="transfer">
          <el-form :model="formData" size="mini">
            <el-form-item label="行业" prop="行业">
              <el-select v-model="formData['行业']" filterable>
                <el-option v-for="(hangye, k) in transferHangyes" :key="k" :label="hangye" :value="hangye"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="*公司" prop="公司">
              <el-autocomplete v-model="formData['公司']" :fetch-suggestions="querySearch"></el-autocomplete>
            </el-form-item>
            <el-form-item label="*模块" prop="模块">
              <el-select v-model="formData['模块']" multiple filterable placeholder="选择">
                <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="*变动因素" prop="变动因素">
              <el-select v-model="formData['变动因素']" filterable placeholder="选择">
                <el-option v-for="t in transferFuncType" :key="t" :label="t" :value="t"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="*变动影响程度" prop="变动影响程度">
              <el-select v-model="formData['变动影响程度']" filterable placeholder="选择">
                <el-option v-for="level in transferFuncLevel" :key="level" :label="level" :value="level"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="变动简述"> <el-input v-model="formData['变动描述']"></el-input> </el-form-item>
            <el-form-item label="详情" prop="详情">
              <el-input v-model="formData['详情']" type="textarea" rows="5"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="isTabShow('bd')" label="招聘信息" name="bd">
          <el-form :model="formData" size="mini">
            <el-form-item label="*公司" prop="公司">
              <el-autocomplete v-model="formData['公司']" :fetch-suggestions="querySearch"></el-autocomplete>
            </el-form-item>
            <el-form-item label="模块" prop="模块">
              <el-select v-model="formData['模块']" multiple filterable placeholder="选择">
                <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门" prop="部门"> <el-input v-model="formData['部门']"></el-input> </el-form-item>
            <el-form-item label="岗位名称" prop="岗位名称">
              <el-input v-model="formData['岗位名称']"></el-input>
            </el-form-item>
            <el-form-item label="岗位类型" prop="岗位类型">
              <el-select v-model="formData['岗位类型']" filterable>
                <el-option v-for="(type, k) in bdType" :key="k" :label="type" :value="type"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="汇报上级" prop="汇报上级">
              <el-input v-model="formData['汇报上级']"></el-input>
            </el-form-item>
            <el-form-item label="岗位详情" prop="岗位详情">
              <el-input v-model="formData['岗位详情']" type="textarea" rows="5"></el-input>
            </el-form-item>
            <el-form-item label="揭榜人" prop="揭榜人">
              <el-select v-model="formData['揭榜人']" filterable placeholder="请选择">
                <el-option v-for="item in accounts" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="BD进展" prop="BD进展">
              <el-input v-model="formData['BD进展']" type="textarea" rows="5"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="isTabShow('others')" label="其他情报" name="others">
          <el-form :model="formData" size="mini">
            <el-form-item label="标题" prop="标题"> <el-input v-model="formData['标题']"></el-input> </el-form-item>
            <el-form-item label="内容" prop="内容">
              <el-input v-model="formData['内容']" type="textarea" rows="5"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <template v-if="isSaveShow">
          <el-button v-show="!formData._id" type="primary" size="mini" @click="saveBulletin">保存</el-button>
          <el-button v-show="formData._id" type="primary" size="mini" @click="updateBulletin">保存</el-button>
        </template>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    bulletinId: { type: String, default: undefined },
  },
  data() {
    return {
      loading: false,
      isSaveShow: true,
      bulletinData: [],
      cateData: [],
      companyData: [],
      accounts: [],
      formData: {},
      searchData: { 模块: [] },
      dialogVisible: false,
      bulletinsType: 'transfer',
      transferHangyes: app.industries || [],
      transferFuncType: [
        '监管因素',
        '股东因素',
        '中高层人员变化',
        '薪酬因素',
        '市场变化',
        '办公地点变化',
        '业务踩雷',
        '公司经营出现问题',
        '裁员',
        '募资到位',
        '募资不到位',
        '其他',
      ],
      transferFuncLevel: [
        '5-导致大批人员离职',
        '4-影响部分人员选择跳槽',
        '3-虽有影响，但人选观望态度',
        '2-公司有相应政策，未产生影响',
        '1-变动是比较好的方向增加人员稳定',
      ],
      bdType: ['5-高端-猎头职位', '4-中端-猎头职位', '3-低端-猎头职位', '2-高端-非猎头职位', '1-中端-非猎头职位'],
    }
  },
  // watch: {
  //   bulletinsType() {
  //     this.clearSearch()
  //   },
  // },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    this.cateData = ['全部'].concat(app.categories.map(cate => cate['名称']))
    Promise.all([this.loadBulletins(this.$route.query.id), this.loadAccount(), this.loadCompany()])
  },
  methods: {
    loadBulletins: async function(id) {
      this.bulletinData = []
      this.loading = true
      const query = typeof id === 'string' ? { _id: id } : Object.assign({ type: this.bulletinsType }, this.searchData)
      const res = await app.service('misc').listBulletins({ isTmp: false, query })
      if (res.status === 'success') {
        this.bulletinData = res.data
        if (id && res.data[0]) this.bulletinsType = res.data[0].type
      } else {
        this.$message.error(res.msg)
      }
      this.loading = false
    },
    loadCompany: async function() {
      let list = await app.service('company').getAbbr()
      list = list.data.map(item => ({
          value: item['简称'],
        }))
      this.companyData = list
    },
    loadAccount: async function() {
      const res = await app.service('misc').listAccounts()
      // console.log(res)
      if (res.status == 'success') {
        this.accounts = res.data.map(u => u.account)
      }
    },
    clearSearch: function() {
      this.searchData = { 模块: [] }
      this.loadBulletins()
    },
    querySearch: async function(queryString, cb) {
      const list = this.companyData
      const results = queryString != null ? list.filter(this.createFilter(queryString)) : list
      return cb(results)
    },
    createFilter: function(queryString) {
      return company => company.value.indexOf(queryString.toLowerCase()) === 0
    },
    addBulletin: async function() {
      this.formData = { 模块: [] }
      if (this.companyData.length === 0) {
        await this.loadCompany()
      }
      if (this.accounts.length === 0) {
        await this.loadAccount()
      }
      this.dialogVisible = true
    },
    valiBulletin: function() {
      if (this.bulletinsType === 'transfer') {
        if (!this.formData['公司']) {
          this.$message.info('请填写公司')
          return false
        }
        if (!this.formData['模块'] || this.formData['模块'].length === 0) {
          this.$message.info('请填写模块')
          return false
        }
        if (!this.formData['变动因素']) {
          this.$message.info('请填写变动因素')
          return false
        }
        if (!this.formData['变动影响程度']) {
          this.$message.info('请填写变动影响程度')
          return false
        }
      } else if (this.bulletinsType === 'bd') {
        if (!this.formData['公司']) {
          this.$message.info('请填写公司')
          return false
        }
      }
      return true
    },
    saveBulletin: async function() {
      if (!this.valiBulletin()) return false
      this.isSaveShow = false
      const formData = Object.assign({}, this.formData)
      if (this.bulletinsType === 'transfer') {
        formData['标题'] = `变动信息 ${formData['公司']}`
        formData['模块'] = formData['模块'].join(',')
      } else if (this.bulletinsType === 'bd') {
        formData['标题'] = `招聘信息 ${formData['公司']}`
        formData['模块'] = formData['模块'].join(',')
      }
      formData['发布人'] = app.user.account
      formData['时间'] = dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss')
      formData.type = this.bulletinsType
      formData.isTmp = false
      const res = await app.service('misc').addBulletin(formData)
      // console.log(res);
      if (res.status === 'success') {
        this.dialogVisible = false
        this.$message.success('新建成功')
        formData._id = res.data.id
        this.bulletinData.unshift(formData)
        this.updateYiyuandu(formData)
      } else {
        this.$message.error(res.msg)
      }
      this.isSaveShow = true
    },
    editBulletin: async function(row) {
      this.formData = Object.assign({}, row)
      const cate = this.formData['模块']
      if (cate && typeof cate === 'string') this.formData['模块'] = this.formData['模块'].split(',')
      this.bulletinsType = row.type
      if (this.companyData.length === 0) {
        await this.loadCompany()
      }
      if (this.accounts.length === 0) {
        await this.loadAccount()
      }
      this.dialogVisible = true
    },
    updateBulletin: async function() {
      if (!this.valiBulletin()) return false
      this.isSaveShow = false
      const formData = Object.assign({}, this.formData)
      formData['模块'] = formData['模块'].join(',')
      formData['发布人'] = app.user.account
      formData['时间'] = dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss')
      formData.type = this.bulletinsType
      formData.isTmp = false
      if (this.bulletinsType === 'transfer') {
        formData['标题'] = `变动信息 ${formData['公司']}`
      } else if (this.bulletinsType === 'bd') {
        formData['标题'] = `招聘信息 ${formData['公司']}`
      }
      const res = await app.service('misc').modifyBulletin({
        _id: formData._id,
        data: formData,
      })
      if (res.status === 'success') {
        this.dialogVisible = false
        this.$message.success('保存成功')
        this.bulletinData = this.bulletinData.map(bull => (bull._id === formData._id ? formData : bull))
        this.updateYiyuandu(formData)
      } else {
        this.$message.error(res.msg)
      }
      this.isSaveShow = true
    },
    delBulletin: async function(row) {
      const res = await app.service('misc').deleteBulletin({ _id: row._id })
      if (res.status === 'success') {
        this.$message.success('删除成功')
        this.bulletinData = this.bulletinData.filter(bull => bull._id !== row._id)
      } else {
        this.$message.error(res.msg)
      }
    },
    isTabShow: function(tab) {
      if (!this.formData._id) {
        return true
      }
      if (tab === this.bulletinsType) {
        return true
      }
      return false
    },
    updateYiyuandu(formData) {
      if (formData.type === 'transfer' && formData['公司']) {
        const num = parseInt(formData['变动影响程度'].slice(0, 1), 10)
        let percent = 0
        if (num === 5) {
          if (percent < 95) {
            percent = 95
          }
        } else if (num === 4) {
          if (percent < 75) {
            percent = 75
          }
        } else if (num === 3) {
          if (percent < 55) {
            percent = 55
          }
        }
        if (num > 2) {
          app.service('misc').updateYiyuandu({
            company: formData['公司'],
            category: formData['模块'],
            percent,
            time: formData['时间'],
          })
        }
      }
    },
  },
}
</script>
